<template>
  <div class="text-left">
    <v-dialog v-model="dialog" width="800">
      <template v-slot:activator="{ on, attrs }">
        <br>
        <v-btn color="deep-purple accent-4" dark v-bind="attrs" v-on="on">click</v-btn>
      </template>

      <v-card elevation="24" max-width="800" class="mx-auto">
        <!-- <v-system-bar lights-out></v-system-bar> -->
        <v-carousel
          :continuous="false"
          :cycle="cycle"
          :show-arrows="true"
          hide-delimiter-background
          delimiter-icon="mdi-minus"
          height="500"
        >
          <v-carousel-item>
            <v-sheet color="white" height="100%" tile>
              <v-row class="fill-height" align="center" justify="center">
                <div class="display-0">
                  <div class="slide">
                    <img src="../assets/ang11.png" width="450" />
                  </div>
                </div>
              </v-row>
            </v-sheet>
          </v-carousel-item>
          <v-carousel-item>
            <v-sheet color="white" height="100%" tile>
              <v-row class="fill-height" align="center" justify="center">
                <div class="display-0 ">
                  <div class="slide">
                    <img src="../assets/ang7.png" width="750" />
                  </div>
                </div>
              </v-row>
            </v-sheet>
          </v-carousel-item>
          <v-carousel-item>
            <v-sheet color="white" height="100%" tile>
              <v-row class="fill-height" align="center" justify="center">
                <div class="display-0 ">
                  <div class="slide">
                    <img src="../assets/ang5.png" width="750" />
                  </div>
                </div>
              </v-row>
            </v-sheet>
          </v-carousel-item>
          <v-carousel-item>
            <v-sheet color="white" height="100%" tile>
              <v-row class="fill-height" align="center" justify="center">
                <div class="display-0 ">
                  <div class="slide">
                    <img src="../assets/ang6.png" width="750" />
                  </div>
                </div>
              </v-row>
            </v-sheet>
          </v-carousel-item>
        </v-carousel>
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <h2>TOEIC BILLS</h2>
              <br />
              Toeic Bills is a Software in house of Aware tectnology solution
              for for employee who want to reimbursed for the cost of the toeic
              test
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialog: false,
      colors: [
        "green",
        "secondary",
        "yellow darken-4",
        "red lighten-2",
        "orange darken-1",
      ],
      cycle: false,
      slides: ["First", "Second", "Third", "Fourth", "Fifth"],
    };
  },
};
</script>
<style scoped>
.slide {
  color: black !important;
}
</style>
